// extracted by mini-css-extract-plugin
module.exports = {"bpTablet":"1050px","bpMobile":"767px"};